export default async ctx => {
  if (ctx.app.$apolloHelpers.getToken()) {
    await ctx.store.dispatch('auth/getCurrentUser', { root: true })
  }
}
